<customer-wrapper>
    <ng-container main-content>
        <div class="form-subsection-container custom-page-row">
            <div class="page-title customer-form-title">
                <div>Edit Customer</div>
            </div>
            <button mat-stroked-button class="default-custom-button" (click)="toggleNotificationsModal()">
                <div class="custom-box-inner icon-button-inner">
                    <div class="icon-wrapper">
                    <img src="assets/icons/mark_email_unread.svg">
                    </div>
                    <div class="custom-box-text">Setup Notifications</div>
                </div>
            </button>
        </div>
        <customer-form [form]="form" [customerSubject]="customerSubject" [usage]="usage" [isFormLoading]="isLoadingCustomer"/>
        <div class="customer-edit-actions">
            <button mat-stroked-button class="delete-button" (click)="delete()">Delete Tenancy</button>
            <div class="submit-actions">
                <button mat-stroked-button routerLink="../../" class="default-custom-button">Cancel</button>
                <button mat-flat-button class="add-button" [disabled]="!form?.valid || form?.pristine" (click)="submitForm()">Save Changes</button>
            </div>
        </div>

        <ng-container *ngIf="isConfiguringNotifications == true">
            <notification-setup-modal (close)="modalClosed()"/>
        </ng-container>
    </ng-container>
</customer-wrapper>